import { useTranslation } from 'next-i18next';
import { QRCodeSVG } from 'qrcode.react';
import * as React from 'react';
import { ReactElement } from 'react';
import ReactToPrint from 'react-to-print';

import { IPrintingOrders } from '@/modules/packhouse/printingOrders/types';
import { Button, Typography } from '@/shared/components/atoms';
import { BaseIcon } from '@/shared/components/atoms/IconButton/BaseIcon';

import PrintIcon from '~/images/shared/print.svg';

interface IProps {
  patchQRCodesData: IPrintingOrders.IGeneratedWorkerQRCodesDataItem[];
}
export default function Exportpdf({ patchQRCodesData }: IProps): ReactElement {
  const { t } = useTranslation('common');
  const QRCodesRef = React.useRef(null);
  return (
    <section>
      <ReactToPrint
        removeAfterPrint
        fonts={[{ family: 'Cairo', source: '' }]}
        content={() => QRCodesRef.current}
        trigger={() => (
          <Button
            color='primary'
            variant='filled'
            className=''
            disabled={patchQRCodesData?.length === 0}
          >
            <div className='flex items-center justify-center gap-2'>
              <BaseIcon size='md'>
                <PrintIcon />
              </BaseIcon>
              {t('print')}
            </div>
          </Button>
        )}
      />

      {/* printed qr codes */}
      <div className='hidden'>
        <div ref={QRCodesRef} className='block'>
          <div className='m-16 grid grid-cols-4 gap-32'>
            {patchQRCodesData?.map((QRCode) => {
              return (
                <div
                  key={QRCode.QRCodeValue}
                  className='m-auto  break-inside-avoid-page'
                >
                  {QRCode.QRCodeValue ? (
                    <QRCodeSVG value={QRCode.QRCodeValue} size={200} />
                  ) : (
                    <Typography
                      variant='subtitle2'
                      weight='bold'
                      className='text-center'
                    >
                      {t('worker-name')}: ({QRCode.workerName})
                    </Typography>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
